import { ScToast } from '@intelipost-js/secure-components';
import { GraphQlClient, Moment } from '@intelipost-js/secure-providers';

export default {
  createOrder({ commit }, params = {}) {
    commit('toggleLoading', true);

    return GraphQlClient.mutation(`
      mutation(
        $quote_id: String,
        $order_number: String!,
        $customer_shipping_costs: Float!,
        $provider_shipping_costs: Float,
        $parent_shipment_order_number: String,
        $sales_channel: String,
        $scheduled: Boolean!,
        $scheduled_delivery_date: String,
        $scheduling_window_start: String,
        $scheduling_window_end: String,
        $shipped_date: Date,
        $sales_order_number: String,
        $shipment_order_type: shipmentOrderTypeEnumScalar,
        $shipment_order_sub_type: shipmentOrderSubtypeEnumScalar,
        $delivery_method_id: Int!,
        $delivery_method_external_id: Int!,
        $created: Date!,
        $end_customer: EndCustomerInput!,
        $origin_name: String,
        $origin_federal_tax_payer_id: String,
        $origin_customer_phone: String,
        $origin_customer_email: String,
        $origin_street: String,
        $origin_number: String,
        $origin_zip_code: String,
        $origin_additional: String,
        $origin_reference: String,
        $origin_quarter: String,
        $origin_city: String,
        $origin_state_code: String,
        $origin_warehouse_code: String,
        $shipment_order_volume_array: [OrderVolumeInput],
        $estimated_delivery_date: Date,
        $additional_information: AdditionalInfoInput,
        $external_order_numbers: ExternalOrderNumberInput,
        $pudo_id: Int,
        $pudo_external_id: String,
        $seller: SellerInput
      ) {
        createOrder(
          quote_id: $quote_id,
          order_number: $order_number,
          customer_shipping_costs: $customer_shipping_costs,
          provider_shipping_costs: $provider_shipping_costs,
          parent_shipment_order_number: $parent_shipment_order_number,
          sales_channel: $sales_channel,
          scheduled: $scheduled,
          scheduled_delivery_date: $scheduled_delivery_date,
          scheduling_window_start: $scheduling_window_start,
          scheduling_window_end: $scheduling_window_end,
          shipped_date: $shipped_date,
          sales_order_number: $sales_order_number,
          shipment_order_type: $shipment_order_type,
          shipment_order_sub_type: $shipment_order_sub_type,
          delivery_method_id: $delivery_method_id,
          delivery_method_external_id: $delivery_method_external_id,
          created: $created,
          end_customer: $end_customer,
          origin_name: $origin_name,
          origin_federal_tax_payer_id: $origin_federal_tax_payer_id,
          origin_customer_phone: $origin_customer_phone,
          origin_customer_email: $origin_customer_email,
          origin_street: $origin_street,
          origin_number: $origin_number,
          origin_zip_code: $origin_zip_code,
          origin_additional: $origin_additional,
          origin_reference: $origin_reference,
          origin_quarter: $origin_quarter,
          origin_city: $origin_city,
          origin_state_code: $origin_state_code,
          origin_warehouse_code: $origin_warehouse_code,
          shipment_order_volume_array: $shipment_order_volume_array,
          estimated_delivery_date: $estimated_delivery_date,
          additional_information: $additional_information,
          external_order_numbers: $external_order_numbers,
          pudo_id: $pudo_id,
          pudo_external_id: $pudo_external_id,
          seller: $seller
        ) {
          order_number
          volumes {
            id
            volume_number
            products {
              id
            }
          }
        }
      }`, params)
    .then(({ data = {} }) => {
      const { createOrder = {} } = data;
      commit('toggleLoading', false);
      ScToast.success('Pedido criado com sucesso');
      return Promise.resolve(createOrder);
    }).catch((err) => {
      commit('toggleLoading', false);
      return Promise.reject(err);
    });
  },
  uploadAttachment({ commit }, params = {}) {
    return GraphQlClient.mutation(`
      mutation(
        url: String,
        content_in_base64: String,
        type: String,
        mime_type: String,
        file_name: String,
        references: [ReferencesInput],
        additional_information: String,
      ){
        uploadAttachments(
          url: $url,
          content_in_base64: $content_in_base64,
          type: $type,
          mime_type: $mime_type,
          file_name: $file_name,
          references: $references,
          additional_information: $additional_information,
        ){
          ok
        }
      }`, params)
    .then((data = {}) => Promise.resolve(data))
    .catch(err => Promise.reject(err));
  },
  getOrder({ commit }, params = {}) {
    commit('toggleLoading', true);

    return GraphQlClient.query(`
      query($order_number: String!) {
        order(order_number: $order_number) {
          id
          created
          is_reverse
          order_number
          parent_order_number
          shipment_order_sub_type
          authorization_code
          sales_order_number
          sales_channel
          provider_shipping_costs
          customer_shipping_costs
          estimated_delivery_client
          end_customer {
            first_name
            last_name
            document
            email
            phone
            cellphone
            address {
              street
              number
              additional
              reference
              quarter
              zip_code
              city
              state
              state_code
              country
            }
          }
          state
          volumes {
            volume_number
            type
            width
            height
            length
            weight
            cost_of_goods
            products_nature
            products_quantity
            invoice {
              number
              serie
              key
              cfop
              date
              products_value
              total_value
            }
            products {
              id
              width
              height
              length
              weight
              price
              description
              sku
              category
              quantity
              image_url
            }
          }
          volumes_qtd
          logistic_provider {
            name
            delivery_method {
              id
              name
            }
          }
          origin {
            name
            email
            federal_tax_payer_id
            address {
              street
              number
              additional
              reference
              quarter
              zip_code
              city
              state
              state_code
              country
            }
          }
          seller {
            first_name
            last_name
            email
            phone
            cellphone
            is_company
            federal_tax_payer_id
            address
            number
            additional
            reference
            quarter
            city
            state
            state_code
            zip_code
            country
          }
          shipped_date
          estimated_delivery_client
          estimated_delivery_transp
          qty_volumes
          is_reverse
          invalid_zip_code
          estimated_collect
        }
      }`, params).then(({ data = {} }) => {
        let volOritem = 'Volume';
        const { order = {} } = data;
        const {
          sales_channel = '',
          order_number = '',
          shipment_order_sub_type = '',
          estimated_delivery_client = new Date(),
          provider_shipping_costs = 0.0,
          end_customer = {},
          origin = {},
          volumes = [],
          is_reverse,
          seller = {},
        } = order;

        const {
          first_name: endCustomerFisrtname = '',
          last_name: endCustomerLastname = '',
          email: endCustomerEmail = '',
          document: federal_tax_payer_id = '',
          phone: endCustomerPhone = '',
          cellphone: endCustomerCellphone = '',
          address: endCustomerAddress = {},
        } = end_customer;

        const {
          street: shipping_address = '',
          number: shipping_number = '',
          additional: shipping_additional = '',
          reference: shipping_reference = '',
          quarter: shipping_quarter = '',
          city: shipping_city = '',
          zip_code: shipping_zip_code = '',
          state: shipping_state = '',
          state_code: shipping_state_code = '',
          shipping_country: shipping_country = '',
        } = endCustomerAddress;

        const {
          name: originName = '',
          email: originEmail = '',
          federal_tax_payer_id: originDocument = '',
          address: originAddress = {},
        } = origin;

        const {
          street: originStreet = '',
          number: originNumber = '',
          additional: originAdditional = '',
          reference: originRef = '',
          quarter: originQuarter = '',
          zip_code: originZipCode = '',
          city: originCity = '',
          state: originState = '',
          state_code: originStateCode = '',
          country: originCountry = '',
        } = originAddress;

        const orderForm = {
          order_number,
          sales_channel,
          isFromApi: true,
          shipment_order_sub_type,
          delivery_date: estimated_delivery_client,
          invoice_total_value: 0.0,
          provider_shipping_costs,
          first_name: endCustomerFisrtname,
          last_name: endCustomerLastname,
          email: endCustomerEmail,
          federal_tax_payer_id,
          phone: endCustomerPhone,
          cellphone: endCustomerCellphone,
          shipping_address,
          shipping_number,
          shipping_additional,
          shipping_reference,
          shipping_quarter,
          shipping_city,
          shipping_zip_code,
          shipping_state,
          shipping_state_code,
          shipping_country,
          delivery_information: {
            name: originName,
            email: originEmail,
            federal_tax_payer_id: originDocument,
            street: originStreet,
            number: originNumber,
            additional: originAdditional,
            reference: originRef,
            quarter: originQuarter,
            zip_code: originZipCode,
            city: originCity,
            state: originState,
            state_code: originStateCode,
            country: originCountry,
          },
        };

        const shipment_order_volume_array = volumes.map((volume = {}) => {
          const {
            volume_number: shipment_order_volume_number,
            type = {},
            width: volWidth = 0,
            height: volHeight = 0,
            length: volLength = 0,
            weight: volWeight = 0,
            products_nature = '',
            products_quantity = 0,
            invoice = {},
          } = volume;

          const { value: volume_type_code = '' } = type;

          const {
            number: invoice_number = 0,
            serie: invoice_series = '',
            key: invoice_key = '',
            date: invoice_date = new Date(),
            products_value: invoice_products_value = 0,
            total_value: invoice_total_value = 0,
            cfop: invoice_cfop = '',
          } = invoice;

          volOritem = 'Volume';

          return {
            shipment_order_volume_number: Number(shipment_order_volume_number),
            order_operation: '',
            reason_for_pidescription: '',
            observations: '',
            products_quantity,
            height: volHeight,
            width: volWidth,
            length: volLength,
            weight: volWeight,
            products_nature,
            products_value: 0,
            volume_type_code,
            shipment_order_volume_invoice: {
              invoice_number,
              invoice_series,
              invoice_key,
              invoice_date: Moment(invoice_date).toDate(),
              invoice_time: Moment(invoice_date).toDate(),
              invoice_total_value,
              invoice_products_value,
              invoice_cfop,
            },
          };
        });

        const validSeller = Object
          .values(seller)
          .filter(val => val !== null && val !== '')
          .length;

        if (!is_reverse) {
          commit('setOrder', order);
          commit('setOrderForm', orderForm);
          commit('setOrderVolumeArray', shipment_order_volume_array);
          commit('setVolumeOrItem', volOritem);

          if (validSeller > 0) {
            commit('setSeller', seller);
            commit('setSellers', seller);
          }
        } else {
          ScToast.danger('Já é um pedido de reversa');
        }
        commit('toggleLoading', false);
        return Promise.resolve(data);
      }).catch((err) => {
        commit('toggleLoading', false);
        commit('setOrder', {});
        commit('resetOrderForm');
        return Promise.reject(err);
      });
  },
  quoteByVolume({ commit }, params = {}) {
    commit('toggleLoading', true);

    return GraphQlClient.mutation(`
      mutation(
        $skip_quote_rules: Boolean,
        $skip_return_modes: Boolean,
        $origin_zip_code: String!,
        $destination_zip_code: String!,
        $logistic_contract_mode: Boolean,
        $shipment_type: Boolean,
        $shipment_sub_type: String,
        $volumes: [VolumeInput]!,
        $contract_ids: [Int],
        $additional_information: AdditionalInformationInput,
        $debug: Boolean
      ){
      quoteFreightVolume(
        skip_quote_rules: $skip_quote_rules,
        skip_return_modes: $skip_return_modes,
        logistic_contract_mode: $logistic_contract_mode,
        shipment_type: $shipment_type,
        shipment_sub_type: $shipment_sub_type,
        origin_zip_code: $origin_zip_code,
        destination_zip_code: $destination_zip_code,
        volumes: $volumes,
        contract_ids: $contract_ids,
        additional_information: $additional_information,
        debug: $debug
      ){
          id
          excluded_methods{
            delivery_restrictions,
            name,
            logo_url,
          }
          logistic_provider{
            delivery_methods{
              id,
              name,
              description,
              final_shipping_cost,
              cost,
              delivery_estimate_business_days,
              type,
              note,
              logo_url,
              logistic_contract_id,
            }
          }
          order{
            qty_volumes
          }
        }
      }`, params)
    .then(({ data = {} }) => {
      const { quoteFreightVolume = {} } = data;
      commit('setQuoteInfo', quoteFreightVolume);
      commit('toggleLoading', false);
      commit('setActiveStep', 2);
      return Promise.resolve(data);
    })
    .catch((err) => {
      commit('toggleLoading', false);
      return Promise.reject(err);
    });
  },
  quoteByProduct({ commit }, params = {}) {
    commit('toggleLoading', true);

    return GraphQlClient.mutation(`
      mutation(
        $origin_zip_code: String!,
        $logistic_contract_mode: Boolean,
        $shipment_type: Boolean,
        $shipment_sub_type: String,
        $destination_zip_code: String!,
        $products: [ProductInput]!,
        $additional_information: AdditionalInformationInput
      ){
      quoteFreightProduct(
        origin_zip_code: $origin_zip_code,
        destination_zip_code: $destination_zip_code,
        products: $products,
        additional_information: $additional_information,
        logistic_contract_mode: $logistic_contract_mode,
        shipment_type: $shipment_type,
        shipment_sub_type: $shipment_sub_type
      ){
          id
          excluded_methods{
            delivery_restrictions,
            name,
            logo_url,
          }
          logistic_provider{
            delivery_methods{
              id,
              name,
              description,
              final_shipping_cost,
              cost,
              delivery_estimate_business_days,
              type,
              note,
              logo_url,
              logistic_contract_id,
            }
          }
          order{
            qty_volumes
          }
        }
      }`, params)
    .then(({ data = {} }) => {
      const { quoteFreightProduct = {} } = data;
      commit('setQuoteInfo', quoteFreightProduct);
      commit('toggleLoading', false);
      commit('setActiveStep', 2);

      return Promise.resolve(data);
    })
    .catch((err) => {
      commit('toggleLoading', false);
      return Promise.reject(err);
    });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-reverse/features/create-reverse/store/actions.js